import React from 'react';
import { Backdrop, CircularProgress, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  };
});

function Loading({
  loading,
  // text,
  // open,
  onClose,
  // type,
  snack,
}) {
  const classes = useStyles();
  return (
    <div>
      <Backdrop open={loading} className={classes.backdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={snack.open}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        autoHideDuration={6000}
        onClose={onClose}
      >
        <Alert onClose={onClose} severity={snack.type}>
          {snack.msg}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default Loading;
